import React from "react";
import { createPortal } from "react-dom";
import styles from "./ReportBottomSheet.module.css";

interface ReportBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onReport: (reason: string) => void;
}

const REPORT_REASONS = [
  "부적절한 컨텐츠",
  "스팸/도배",
  "욕설/비하",
  "불법 정보",
  "개인정보 노출",
  "기타",
];

const ReportBottomSheet: React.FC<ReportBottomSheetProps> = ({
  isOpen,
  onClose,
  onReport,
}) => {
  const modalContent = (
    <>
      <div
        className={styles.overlay}
        style={{ display: isOpen ? "block" : "none" }}
        onClick={onClose}
      />
      <div
        className={`${styles.bottomSheet} ${isOpen ? styles.open : ""}`}
        aria-hidden={!isOpen}
      >
        <div className={styles.header}>
          <h3>신고하기</h3>
        </div>
        <div className={styles.content}>
          <p className={styles.description}>신고 사유를 선택해 주세요</p>
          <div className={styles.reasonList}>
            {REPORT_REASONS.map((reason) => (
              <button
                key={reason}
                className={styles.reasonButton}
                onClick={() => {
                  onReport(reason);
                  onClose();
                }}
              >
                {reason}
              </button>
            ))}
          </div>
        </div>
        <button className={styles.cancelButton} onClick={onClose}>
          취소
        </button>
      </div>
    </>
  );

  return createPortal(modalContent, document.body);
};

export default ReportBottomSheet;
